import { useStorageState } from 'react-storage-hooks';
export function storageObject(type = 'local') {
    const noop = () => null;
    const dummyStorage = {
        getItem: () => null,
        setItem: noop,
        removeItem: noop,
    };
    if (typeof window === 'undefined') {
        return dummyStorage;
    }
    return window[`${type}Storage`];
}
export function useLocalStorage(localStorageName) {
    return useStorageState(storageObject(), localStorageName);
}
